import {
    Box,
    Button,
    Card,
    IconButton,
    Tooltip,
    Typography,
    Zoom,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import React from 'react';

export const LocationItem = ({ address, handleEditAddress, modalAlert }) => {
    return (
        <Card sx={{ mb: 2, padding: 2, borderRadius: 3 }} elevation={0}>
            <Box display='flex' justifyContent='space-between'>
                <Box>
                    <Typography
                        fontSize={'12px'}
                        variant={'h6'}
                        color={'text.secondary'}
                        mb={0.25}
                    >
                        Tipo de Endereço
                    </Typography>

                    <Typography mt={1}>{address?.tipo_de_endereco}</Typography>
                </Box>
                <Box>
                    <Typography
                        fontSize={'12px'}
                        variant={'h6'}
                        color={'text.secondary'}
                        mb={0.25}
                    >
                        Logradouro
                    </Typography>

                    <Typography mt={1}>{address?.logradouro}</Typography>
                </Box>

                <Box>
                    <Typography
                        fontSize={'12px'}
                        variant={'h6'}
                        color={'text.secondary'}
                        mb={0.25}
                    >
                        Bairro
                    </Typography>

                    <Typography mt={1}>{address?.bairro}</Typography>
                </Box>

                <Box>
                    <Typography
                        fontSize={'12px'}
                        variant={'h6'}
                        color={'text.secondary'}
                        mb={0.25}
                    >
                        Cidade
                    </Typography>

                    <Typography mt={1}>{address?.cidade}</Typography>
                </Box>

                <Box>
                    <Typography
                        fontSize={'12px'}
                        variant={'h6'}
                        color={'text.secondary'}
                        mb={0.25}
                    >
                        UF
                    </Typography>

                    <Typography mt={1}>{address?.uf}</Typography>
                </Box>

                <Box>
                    <Typography
                        fontSize={'12px'}
                        variant={'h6'}
                        color={'text.secondary'}
                        mb={0.25}
                    >
                        Ação
                    </Typography>
                    <Box display={'flex'} gap={1}>
                        <Tooltip title='Editar' TransitionComponent={Zoom}>
                            <IconButton
                                aria-label='editar'
                                color='info'
                                onClick={() => handleEditAddress(address)}
                            >
                                <EditIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title='Remover' TransitionComponent={Zoom}>
                            <IconButton
                                aria-label='remover'
                                color='error'
                                onClick={() => modalAlert(address.id)}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </Box>
        </Card>
    );
};
